import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { CoverageApi } from './apis/coverage-api';
import { CoverageApiImpl } from './apis/impls/coverage-api';
import { CoverageRepository } from './services/coverage-repository';
import { CoverageRepositoryImpl } from './repositories/impls/coverage-repository';

export const coverageContainer = new ContainerModule(bind => {
    bind(CoverageRepository).to(CoverageRepositoryImpl);
    bind(CoverageApi).to(CoverageApiImpl);
});
